/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 12 to version 13
 * - Adds blueprintOverrides field ({}) to all kitchens for per-field text overrides from contentEditable editing
 */

export const u13 = (blueprint: any): any => {
	console.log('schema-update:process-update:13:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 13;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				if (kitchen.blueprintOverrides === undefined) {
					kitchen.blueprintOverrides = {};
				}
			});
		}

		console.log('schema-update:process-update:13:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:13:error', err);
		return null;
	}
};
